module.exports = __webpack_public_path__ + "img/fullart.30e2d74e.png";